import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import * as Api from '../../api/paymentsApi';
import { selectors as companySelectors } from '../company';
import { errorHelper, responseValidateStatusOrThrow } from '../helpers';
import { selectors as siteSelectors } from '../sites';
import types from './types';

export function* startTrialVersion() {
  try {
    const companyId = yield select(companySelectors.getCompanyId);
    const siteId = yield select(siteSelectors.getSiteId);
    const response = yield call(Api.startTrialVersion, companyId, siteId);
    yield responseValidateStatusOrThrow(response);
    const { data } = response;
    yield put({ payload: data, type: types.START_TRIAL_SUCCESS });
  } catch (error) {
    yield put(errorHelper(types.START_TRIAL_FAILURE, error));
  }
}



export default function* paymentsSagas() {
  yield all([
    takeEvery(types.START_TRIAL_REQUEST, startTrialVersion)
  ]);
}
